import { LOCALES } from './locales'
import en from './locales/en'

export const messages = {
    [LOCALES.ENGLISH]: en
}